import { createAsyncThunk } from '@reduxjs/toolkit';
import { _priceUrls } from '@custom/Utils/constants/apiUrls';

const getModalityStudy = createAsyncThunk('getModalityStudy', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = _priceUrls.getModalityStudy;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch price data');
    }
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getModalityStudy;
